/* eslint-disable no-useless-escape */
/* eslint-disable eqeqeq */
import { BUSINESS_TIMER, commonConstants, GOODS_DROP_TYPE, LOCAL_PATH, MINUS_WAREHOUSE, MIX_TYPE, PRODUCT_CATEGORY, ROUNDING_PRINCIPLE, SALE_TYPE, STATUS_VM, SUBSOURCE, VALUE_STATUS_VM } from "../constant";
import moment from "moment";
import { VMProductInfoDto } from "../dto/vending/VMProductInfoDto";
import { PromotionDto } from "../dto/vending/PromotionDto";
import { PromotionProductDto } from "../dto/vending/PromotionProductDto";
import { ComboDto } from "../dto/vending/ComboDto";
import { ProductDto } from "../dto/vending/ProductDto";
import { CategoryPromotionEnum, MachineModelTypeEnum, WalletEnum } from "../constant/enum.constants";
import { CartItemDto } from "../dto/cart/cartItemDto";
import md5 from 'md5';
import { ResLayoutDto } from "../dto/layout/Response/ResLayout";
import { MachineDto } from "../dto/vending/MachineDto";
import { SubLayoutDto } from "../dto/layout/Dto/SubLayoutDto";
import { TrayDto } from "../dto/layout/Dto/TrayDto";
import { SlotDto } from "../dto/layout/Dto/SlotDto";
import { BillDto } from "../dto/vending/BillDto";

export const utils = {
  swap,
  dateFromStamp,
  delay,
  moveArrayItemsToTop,
  convertMeterToKilometer,
  makeUUID,
  genBillForZalo,
  getUrlByStatusVM,
  isValidURL,
  isValidFileVideo,
  checkStringValid,
  getPlatform,
  countBillOnProducts,
  countCartItemValue,
  mapPromotionToProduct,
  randomColor,
  capchaCode,
  getItemMaxQty,
  countCartTotal,
  removeVietnameseTones,
  getOriginAmountByBill,
  isCheckShowPromoParallel,
  isCheckShowPromoVoucher,
  isCheckShowPromoSamling,
  isOpenBusiness,
  getPromotionByShowIcon,
  getHash,
  getFullPath,
  getBillNumber,
  getProductGroupByLayout,
  getBillOffline,
  isLocationMatch,
  getContentClassNameByLang,
  createOrderWallet,
  createOrderEvent,
  getPromotionByOperation,
  getPromotionComboByOperation,
  verifySignature,
  verifySignatureVinaId,
  isAddPromotionOperation,
  getPlatformType,
  safeConcat,
  checkDomainKootoro,
  checkDomainBlueoceanlaundry
};

/**
 * Delay 1 while
 *
 * @param ms - amount of milliseconds
 */
function delay(ms: number) {
  return new Promise((res) => setTimeout(res, ms));
}

function swap(array, position1, postition2) {
  let changedArray = array;
  try {
    let object1 = changedArray[position1];
    let object2 = changedArray[postition2];
    changedArray[postition2] = object1;
    changedArray[position1] = object2;
    return changedArray;
  } catch (err) {
    console.log(err);
    return array;
  }
}

function dateFromStamp(stamp) {
  if (stamp) {
    try {
      var date = new Date(stamp);
      return date;
    } catch (err) {
      console.log(err);
      return undefined;
    }
  }
  return undefined;
}


/**
 * Move an array to top
 */
function moveArrayItemsToTop<T>(
  arrayItemsToMove: T[],
  origin: T[],
  compareFunction: Function
) {
  arrayItemsToMove.forEach((e) => {
    let check = origin.filter((k) => compareFunction(e, k));
    if (check && check.length) {
      let index = origin.indexOf(check[0]);
      origin.splice(index, 1);
      origin.unshift(check[0]);
    }
  });
  return origin;
}

/**
 * Convert meter to kilometer
 * @param input input number
 */
function convertMeterToKilometer(input: number) {
  if (input && typeof input === "number") {
    let res = input / 1000;
    return `${Math.round((res + +Number.EPSILON) * 100) / 100} km`;
  }
  return "";
}

/**
 * Automatic code generation
 * @param length string
 */
function makeUUID(length: number) {
  var result = '';
  var characters = commonConstants.CHARACTERS;
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
/**
 * Bill zalo
 * @param length string
 */
function genBillForZalo(length: number) {
  var billNumber = makeUUID(length);

  var year = moment().year().toString();
  var month = (moment().month() + 1).toString();
  var day = moment().date().toString();
  day = day.length == 1 ? "0" + day : day;
  month = month.length == 1 ? "0" + month : month;
  year = year.substring(year.length - 2, year.length);
  let yymmdd = year + month + day;
  return yymmdd + "_" + billNumber;
}

/**
 * Is valid URL
 * @param url string
 */
function isValidURL(url: string) {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(url);
}

/**
 * Is valid video
 * @param url string
 */
function isValidFileVideo(filePath: string) {
  if (checkStringValid(filePath)) {
    var extension = filePath.split('.').pop().toLowerCase();
    var lstEx = ['png', 'gif', 'jpeg', 'jpg', 'bmp'];
    if (lstEx.indexOf(extension) == -1) {
      // Video 
      return true;
    } else {
      // Img
      return false;
    }
  } else {
    return false;
  }
}

function getUrlByStatusVM(machine: any, screen: string, subsource: string, method: string, paymentMethod: string, partnerStoreCode?: string) {
  var data = {
    queryString: "",
    statusVM: "",
  };
  let codePrefix = checkStringValid(machine?.code) ? `?code=${machine.code}` : `?partnerStoreCode=${partnerStoreCode}`
  var urlsub = (subsource ? `&subsource=${subsource}` : "").concat(method ? `&method=${method}` : "").concat(paymentMethod ? `&paymentMethod=${paymentMethod}` : "");
  if (machine?.statusMaintenance == VALUE_STATUS_VM.MAINTENANCE.MAINTENANCED) {
    // Trạng thái bảo trì
    // updateStatusVM(STATUS_VM.STATUS_MAINTENANCED);
    data.statusVM = STATUS_VM.STATUS_MAINTENANCED;
    let urlStr = codePrefix.concat(`&status=${STATUS_VM.STATUS_MAINTENANCED}`).concat(urlsub);
    data.queryString = LOCAL_PATH.STATUS_VM.concat(urlStr);
    // navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
  }
  else {
    if (machine?.statusBusiness == VALUE_STATUS_VM.BUSINESS.IN_BUSINESS) {
      if (machine?.statusFillGoods == VALUE_STATUS_VM.FILLING_GOODS.IN_FILLING_GOODS) {
        // HIển thị thông báo đang nạp hàng, vui lòng đợi trong ít phút(màn hình mới)
        // updateStatusVM(STATUS_VM.STATUS_FILL_GOODS);
        data.statusVM = STATUS_VM.STATUS_FILL_GOODS;
        let urlStr = codePrefix.concat(`&status=${STATUS_VM.STATUS_FILL_GOODS}`).concat(urlsub);
        data.queryString = LOCAL_PATH.STATUS_VM.concat(urlStr);
        // navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
      }
      else if (machine?.statusFillGoods == VALUE_STATUS_VM.FILLING_GOODS.NOT_YET_FILLED_GOODS) {
        // Hiển thị thông báo các sản phẩm chưa sãn sàng(hiện tại đã có)
        // updateStatusVM(STATUS_VM.STATUS_NOT_READY_GOODS);
        data.statusVM = STATUS_VM.STATUS_NOT_READY_GOODS;
        let urlStr = codePrefix.concat(`&status=${STATUS_VM.STATUS_NOT_READY_GOODS}`).concat(urlsub);

        data.queryString = LOCAL_PATH.STATUS_VM.concat(urlStr);
        // navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
      }
      else {
        // Hiển thị màn hình bán hàng
        let urlStr = codePrefix.concat(urlsub);
        if (screen == "APP") {
          data.queryString = LOCAL_PATH.HOME.concat(urlStr);;
        } else {
          data.queryString = "";
        }
      }
    }
    else if (machine?.statusBusiness == VALUE_STATUS_VM.BUSINESS.STOPPED_BUSINESS) {
      // Hiển thị thông báo hệ thống đang bảo trì(hiện tại đã có)
      // updateStatusVM(STATUS_VM.STATUS_MAINTENANCED);
      data.statusVM = STATUS_VM.STATUS_MAINTENANCED;
      // queryString = (`?status=${STATUS_VM.STATUS_MAINTENANCED}`).concat(paymentMethod ? `&paymentMethod=${paymentMethod}` : "");
      let urlStr = codePrefix.concat(`&status=${STATUS_VM.STATUS_MAINTENANCED}`).concat(urlsub);
      data.queryString = LOCAL_PATH.STATUS_VM.concat(urlStr);
      // navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
    }
    else {
      // Hiển thị màn hình Opening soon(hiện tại đã có)
      // updateStatusVM(STATUS_VM.VM_OPENING_SOON);
      data.statusVM = STATUS_VM.VM_OPENING_SOON;
      // queryString = (`?status=${STATUS_VM.VM_OPENING_SOON}`).concat(paymentMethod ? `&paymentMethod=${paymentMethod}` : "");
      let urlStr = codePrefix.concat(`&status=${STATUS_VM.VM_OPENING_SOON}`).concat(urlsub);
      data.queryString = LOCAL_PATH.STATUS_VM.concat(urlStr);
      // navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
    }
  }
  return data;
}

/**
 * Check if a params string is valid
 * @param s: String to be checked
 * @return boolean
 */
function checkStringValid(s: string) {
  return s !== null && s !== "null" && s !== undefined && s !== "" && s !== `""` && s !== "undefined";
}


/**
 * get Platform by userAgent
 * @param s: String to be checked
 * @return string
 */
function getPlatform() {
  let result = "";
  let userAgent = navigator.userAgent;
  let arr = userAgent.match(/Android|iPhone|iPad|iPod|Mac|Windows|Win32|webOS|BlackBerry|IEMobile|Opera Mini/ig);
  if (arr && arr.length > 0) {
    result = arr[0];
  }
  return result;
}


/**
 * Get item have quantity max
 * @param cartItems
 */
function getItemMaxQty(cartItems: CartItemDto[]) {
  let itemMax = cartItems[0];
  let length = cartItems.length;
  for (let i = 1; i < length; ++i) {
    if (cartItems[i].quantity > itemMax.quantity) {
      itemMax = cartItems[i];
    }
  }
  return itemMax;
}


/**
 * Handle count bill money from product only
 * @param cartItems
 */
function countBillOnProducts(cartItems: CartItemDto[]) {
  let total = 0;
  cartItems?.forEach((e) => {
    total += countCartItemValue(e);
  });
  return total;
}


/**
 * Handle count cart items value price
 * @param product
 */
function countCartItemValue(cartItem?: CartItemDto) {
  return cartItem.product.newPrice * cartItem?.quantity;
}


function countCartTotal(cartItems: CartItemDto[]) {
  if (cartItems === undefined || cartItems === null) {
    return 0;
  }
  let total = 0;
  cartItems.forEach((e, i) => {
    total += e?.quantity ?? 0;
  });
  return total;
}


/**
 * Handle count bill money from product only
 * @param cartItems
 */
function getOriginAmountByBill(cartItems: CartItemDto[]) {
  let total = 0;
  cartItems?.forEach((e) => {
    total += getOriginAmountByQty(e);
  });
  return total;
}


/**
 * Handle count cart items value price
 * @param product
 */
function getOriginAmountByQty(cartItem?: CartItemDto) {
  return cartItem.product.sellingPrice * cartItem?.quantity;
}


/**
 * Map thông tin khuyến mãi vào product
 */
function mapPromotionToProduct(lstProductLayout: Array<VMProductInfoDto>, lstPromotion: Array<PromotionDto>) {
  // 1: Giảm giá sản phẩn , 2: Điều chỉnh giá ( chính sách giá) , 3: Giá Grab(không sử dụng nữa) , 4: Khuyến mãi ko rớt hàng, 5: Khuyến mãi có rớt hàng, 6: Khuyến mãi combo, 7 voucher, 8 acquire user
  // loop list product
  lstProductLayout.forEach(product => {
    // loop list promotion 
    lstPromotion.forEach(data => {
      // Khuyến mãi combo
      const isAddPromotion = isAddPromotionOperation(data);
      if (data.promotionCategory == CategoryPromotionEnum.PROMOTION_COMBO && isAddPromotion) {
        // List combo in promotion 
        data.comboes.forEach(item => {
          // List product in promtion
          if (item.products != null) {
            // var result = isPromotionCombo(item.products, product);
            item.products.forEach(pro => {
              if (pro.id == product.id) {
                let promoCombo = getPromotionComboDto(data, item, lstProductLayout, lstPromotion);
                if (promoCombo) {
                  product.promotionList.push(promoCombo);
                }
              }
            });
          }
        });
      } else if (data.promotionCategory == CategoryPromotionEnum.PROMOTION_SAMPLING && isAddPromotion) {
        // promotion samling
        data.products.forEach(pro3 => {
          if (pro3.id == product.id) {
            let promotion = addPromotionDto(data, pro3);
            promotion.messages = data.messages;
            // Sản phẩm có samling
            promotion.samlinngType = "SINGLE";
            product.promotionList.push(promotion);
          }
        })
        // List combo in promotion 
        data.comboes.forEach(item => {
          // List product in promtion
          if (item.products != null) {
            // var result = isPromotionCombo(item.products, product);
            item.products.forEach(pro => {
              if (pro.id == product.id) {
                let promoCombo = getPromotionComboDto(data, item, lstProductLayout, lstPromotion);
                if (promoCombo) {
                  promoCombo.messages = data.messages;
                  promoCombo.samlinngType = "COMBO";
                  // Sam phẩm samling có combo
                  product.promotionList.push(promoCombo);
                }
              }
            });
          }
        });
      } else if (data.promotionCategory == CategoryPromotionEnum.PROMOTION_VOUCHER && isAddPromotion) {
        if (data.isApplyAllProduct) {
          let isMatching = product.ownerType == data.productOwnerType && product.ownerId == data.productOwnerId;
          if (isMatching) {
            let promotion = addPromotionDto(data, null);
            promotion.minBuyQuanlityGift = Number(data.maxBuyQuantity ?? 1);
            product.promotionList.push(promotion);
          }
        } else {
          data.products.forEach(pro => {
            if (pro.id == product.id) {
              let promotion = addPromotionDto(data, pro);
              promotion.minBuyQuanlityGift = Number(pro.minBuyQuanlity ?? 1);
              product.promotionList.push(promotion);
            }
          });
        }
      } else if (data.promotionCategory == CategoryPromotionEnum.PROMOTION_NO_DROP && isAddPromotion) {
        if (data.isApplyAllProduct) {
          let isMatching = product.ownerType == data.productOwnerType && product.ownerId == data.productOwnerId;
          if (isMatching) {
            let promotion = addPromotionDto(data, null);
            promotion.messages = data.messages;
            product.promotionList.push(promotion);
          }
        } else {
          data.products.forEach(pro => {
            if (pro.id == product.id) {
              let promotion = addPromotionDto(data, pro);
              promotion.messages = data.messages;
              product.promotionList.push(promotion);
            }
          });
        }
      } else if (data.promotionCategory == CategoryPromotionEnum.PROMOTION_NORMAL && isAddPromotion) {
        if (data.isApplyAllProduct) {
          let isMatching = product.ownerType == data.productOwnerType && product.ownerId == data.productOwnerId;
          if (isMatching) {
            let promotion = addPromotionDto(data, null);
            promotion.amountDiscount = data.amountDiscount;
            promotion.percentDiscount = data.percentDiscount;
            // Nếu promo giảm giá có theo HSD  
            if (data.isDiscountByExpirationDate) {
              let nowAddDays = moment().add(Number(data.discountByExpirationDateValue ?? 0), "days");
              // Thời gian hiện tại + số ngày >= hạn sử dụng sản phẩm 
              if (product.expiredDate
                && moment(nowAddDays).isSameOrAfter(moment(product.expiredDate))
                && (promotion.amountDiscount > 0 || promotion.percentDiscount > 0)) {
                product.promotionList.push(promotion);
              }
            } else if (promotion.amountDiscount > 0 || promotion.percentDiscount > 0) {
              // Nếu promo chỉ giảm giá thì cứ thêm vào 
              product.promotionList.push(promotion);
            }
          }
        } else {
          data.products.forEach(pro => {
            if (pro.id == product.id) {
              let promotion = addPromotionDto(data, pro);
              // Nếu promo giảm giá có theo HSD  
              if (data.isDiscountByExpirationDate) {
                let nowAddDays = moment().add(Number(pro.numberOfDay ?? 0), "days");
                // Thời gian hiện tại + số ngày >= hạn sử dụng sản phẩm 
                if (product.expiredDate
                  && moment(nowAddDays).isSameOrAfter(moment(product.expiredDate))
                  && (promotion.amountDiscount > 0 || promotion.percentDiscount > 0)) {
                  product.promotionList.push(promotion);
                }
              } else if (promotion.amountDiscount > 0 || promotion.percentDiscount > 0) {
                // Nếu promo chỉ giảm giá thì cứ thêm vào 
                product.promotionList.push(promotion);
              }
            }
          });
        }
      } else if (data.promotionCategory == CategoryPromotionEnum.PROMOTION_DISCOUNT) {
        if (data.isApplyAllProduct) {
          let isMatching = product.ownerType == data.productOwnerType && product.ownerId == data.productOwnerId;
          if (isMatching) {
            let promotion = addPromotionDto(data, null);
            promotion.amountDiscount = data.amountDiscount;
            promotion.percentDiscount = data.percentDiscount;
            product.promotionList.push(promotion);
          }
        } else {
          data.products.forEach(pro => {
            if (pro.id == product.id) {
              let promotion = addPromotionDto(data, pro);
              promotion.messages = data.messages;
              product.promotionList.push(promotion);
            }
          });
        }
      } else {
        data?.products.forEach(pro2 => {
          if (pro2.id == product.id) {
            let promotion = addPromotionDto(data, pro2);
            if (data.promotionCategory == CategoryPromotionEnum.PROMOTION_DROP_PRODUCT && isAddPromotion) {
              let giftProduct = lstProductLayout.find(x => x.id == pro2.giftProductId);
              if (giftProduct != null && giftProduct.quantity >= (pro2.giftQuanlity ?? 1)) {
                // id sản phẩm tặng
                promotion.idProductGift = pro2.giftProductId;
                promotion.codeProductGift = giftProduct.code;
                promotion.nameProductGift = giftProduct.fullName;
                promotion.brandIdProductGift = giftProduct.brandId;
                promotion.weightIncludePackaging = giftProduct.weightIncludePackaging;
                promotion.imageProductGift = giftProduct.image;
                promotion.categoryProductGift = giftProduct.category;
                promotion.sellingPriceProductGift = giftProduct.sellingPrice;
                // Số lượng tặng
                promotion.quanlityProductGift = pro2.giftQuanlity ?? 1;
                // Số lượng tồn kho của sản phẩm tặng
                promotion.quantityProductGift = giftProduct.quantity;
                // số lượng tối thiểu phải mua mới đc tặng
                promotion.minBuyQuanlityGift = pro2.minBuyQuanlity ?? 1;
                // Kiếm tra sản phẩm tặng chính là sản phẩm bán
                if (giftProduct.id != product.id || (giftProduct.id == product.id && giftProduct.quantity > (pro2.minBuyQuanlity ?? 1))) {
                  product.promotionList.push(promotion);
                }
              }
            }
          }
        });
      }
    });
    // #17702 Tại 1 thời điểm, cho phép áp dụng nhiều chương trình giảm giá sản phẩm, lọc điều kiện giảm giá nào tốt nhất (giảm nhiều nhất) áp dụng cho KH.
    let lstFilterNormal = product?.promotionList?.filter(x => x.promotionCategory == CategoryPromotionEnum.PROMOTION_NORMAL);
    if (lstFilterNormal && lstFilterNormal.length > 0) {
      let newPrice = getNewPriceByPromoNormal(lstFilterNormal[0], product.sellingPrice);
      let promo = lstFilterNormal[0];
      lstFilterNormal.forEach(itemPromo => {
        let price = getNewPriceByPromoNormal(itemPromo, product.sellingPrice);
        if (price < newPrice) {
          newPrice = price;
          promo = itemPromo;
        }
      });
      product.newPrice = newPrice;
      let lstRemove = lstFilterNormal.filter(x => x.id != promo.id);
      lstRemove?.forEach(itemRemove => {
        let finding = lstFilterNormal.find(x => x.id === itemRemove.id);
        let index = product?.promotionList?.indexOf(finding);
        product?.promotionList?.splice(index, 1);
      })
    } else {
      product.newPrice = product.sellingPrice;
    }
  });
};

function isAddPromotionOperation(promotion: PromotionDto) {
  let isOperation = true;
  if (promotion.operationByDateList && promotion.operationByDateList.length > 0) {
    let dayNow = moment().format("YYYY-MM-DD");
    let dayOfWeek = moment().day();
    let currentTime = moment().format("HH:mm:ss.SSS");
    let itemSpecial = promotion.operationByDateList.find(x => x.type == "SPECIALIZE" && x.value == dayNow);
    let itemNormal = promotion.operationByDateList.find(x => x.type == "WEEKLY" && x.value == dayOfWeek);
    // Ưu tiên ngày đặc biệt
    let itemByDate = itemSpecial || itemNormal;

    if (itemByDate != null) {
      // Có dữ liệu và áp dụng nguyên ngày
      if (itemByDate.range == "FULL_DAY") {
        isOperation = itemByDate.status == "ON" ? true : false;
      } else if (itemByDate.range == "FRAME_TIME") {
        // Tìm khung thời gian hợp lý
        let itemFrameTime = itemByDate.operationFrameTimeList.find(x => moment(currentTime, "HH:mm:ss.SSS").isBetween(moment(x.fromTime, "HH:mm:ss.SSS"), moment(x.toTime, "HH:mm:ss.SSS")));
        if (itemByDate.status == "ON") {
          // Nếu ON mà có => true
          // Nếu ON ko có => false
          isOperation = itemFrameTime ? true : false;
        } else {
          // Nếu OFF mà có => false
          // Nếu OFF ko có => true
          isOperation = itemFrameTime ? false : true;
        }
      }
    }
  }
  return isOperation

}



function getNewPriceByPromoNormal(itemPromo: PromotionDto, sellingPrice: number) {
  let newPrice = sellingPrice;
  if (itemPromo.amountDiscount) {
    newPrice = getNewPriceByAmount(sellingPrice, itemPromo.amountDiscount);
  }
  else if (itemPromo.percentDiscount) {
    newPrice = getNewPriceByPercent(sellingPrice, itemPromo.percentDiscount, itemPromo);
  }
  return newPrice;
}

function getNewPriceByPercent(oldPrice: number, percent: number, promotion: PromotionDto) {
  let priceDiscount = (oldPrice * percent / 100);
  let finalAmount = Math.floor(Math.abs(priceDiscount) / 1000) * 1000;
  let roundingValue = (promotion?.roundingValue ?? 1000);
  switch (promotion.roundingPrinciple) {
    case ROUNDING_PRINCIPLE.FLOOR:
      finalAmount = Math.floor(Math.abs(priceDiscount) / roundingValue) * roundingValue;
      break;
    case ROUNDING_PRINCIPLE.CEILING:
      finalAmount = Math.ceil(Math.abs(priceDiscount) / roundingValue) * roundingValue;
      break;
    case ROUNDING_PRINCIPLE.HALF_ROUND_UP:
      finalAmount = Math.round(Math.abs(priceDiscount) / roundingValue) * roundingValue;
      break;
    case ROUNDING_PRINCIPLE.HALF_ROUND_DOWN:
      finalAmount = -Math.round(-(Math.abs(priceDiscount) / roundingValue)) * roundingValue;
      break;
    default:
      return finalAmount;
  }
  let price = oldPrice - finalAmount
  price = price < 0 ? 0 : price;
  return price;
}

function getNewPriceByAmount(oldPrice: number, amount: number) {
  var price = oldPrice - amount;
  price = price < 0 ? 0 : price;
  return price;
}

function addPromotionDto(promotion: PromotionDto, promotionProduct: PromotionProductDto) {
  let promoDto = new PromotionDto();
  promoDto.id = promotion.id;
  promoDto.amountDiscount = promotionProduct?.amountDiscount;
  promoDto.percentDiscount = promotionProduct?.percent;
  promoDto.giftType = promotion.giftType;
  promoDto.code = promotion.code;
  promoDto.endDate = promotion.endDate;
  promoDto.endTime = promotion.endTime;
  promoDto.name = promotion.name;
  promoDto.startDate = promotion.startDate;
  promoDto.startTime = promotion.startTime;
  promoDto.promotionType = promotion.promotionType;
  promoDto.promotionCategory = promotion.promotionCategory ?? 0;
  promoDto.isLoseMessage = promotion.isLoseMessage;
  promoDto.isWinMessage = promotion.isWinMessage;
  promoDto.isTimeFrame = promotion.isTimeFrame;
  promoDto.aPILink = promotion.aPILink;
  promoDto.isIntergatePartner = promotion.isIntergatePartner;
  promoDto.minBuyQuanlityGift = promotionProduct?.minBuyQuanlity;
  promoDto.operationType = promotion?.operationType;
  promoDto.operationId = promotion?.operationId;
  promoDto.productOwnerType = promotion?.productOwnerType;
  promoDto.productOwnerId = promotion?.productOwnerId;
  promoDto.partyPayFee = promotion?.partyPayFee;
  promoDto.partnerId = promotion?.partnerId;
  promoDto.termsAndConditions = promotion?.termsAndConditions;
  promoDto.isDiscountByExpirationDate = promotion?.isDiscountByExpirationDate;
  promoDto.roundingValue = promotion?.roundingValue;
  promoDto.roundingPrinciple = promotion?.roundingPrinciple;
  promoDto.isShowIcon = promotion?.isShowIcon;
  promoDto.operationByDateList = promotion.operationByDateList;
  return promoDto;
}

function getPromotionComboDto(promotion: PromotionDto, combo: ComboDto, lstProductLayout: Array<VMProductInfoDto>, lstPromotion: Array<PromotionDto>) {
  let promoDto = new PromotionDto();
  let productForCombos = getProductForCombo(lstProductLayout, combo, lstPromotion);
  let lenngthCombo = productForCombos?.length;
  if (lenngthCombo != combo?.products?.length) {
    return null;
    // promoDto.isSoldOutCombo = true;
  } else {
    // Có tồn tại 1 thằng hết hạn hoặc hết hàng thì là Hết hàng
    let findSoldOut = productForCombos.find(x => !x.expiredDate || moment().isSameOrAfter(moment(x.expiredDate)) || x.qty <= 0);
    if (findSoldOut) {
      promoDto.isSoldOutCombo = true;
      promoDto.isExpiredCombo = false;
      promoDto.qtyCombo = 0;
    }
    // TH tồn tại sản phẩm trùng tong combo
    let group = productForCombos.reduce((r, a) => {
      r[a.id] = [...r[a.id] || [], a];
      return r;
    }, {});

    let arrGroup = Object.keys(group).map((key) => group[key]);
    // let arrCheck = arrGroup?.filter(x => x.length >= 2);
    let min = 0;
    if (arrGroup) {
      arrGroup?.forEach((item, index) => {
        let qty = item[0]?.qty;
        let length = item.length;
        let y = Math.floor(qty / (length == 0 ? 1 : length));
        if (index == 0) {
          min = y;
        }
        if (y < min) {
          min = y;
        }
        if (length >= 2 && qty < length) {
          promoDto.isSoldOutCombo = true;
          promoDto.isExpiredCombo = false;
        }
      });
    }
    if (promoDto.isSoldOutCombo || promoDto.isExpiredCombo) {
      promoDto.qtyCombo = 0;
    } else {
      promoDto.qtyCombo = min;
    }
    // Tất cả các sản phẩm trong Combo hết hạn
    let filterExpired = productForCombos.filter((x) => moment().isSameOrAfter(moment(x.expiredDate)));
    if (filterExpired.length == productForCombos.length) {
      promoDto.isSoldOutCombo = false;
      promoDto.isExpiredCombo = true;
      promoDto.qtyCombo = 0;
    }
  }
  promoDto.id = promotion.id;
  promoDto.code = promotion.code;
  promoDto.endDate = promotion.endDate;
  promoDto.endTime = promotion.endTime;
  promoDto.name = promotion.name;
  promoDto.startDate = promotion.startDate;
  promoDto.startTime = promotion.startTime;
  promoDto.promotionType = promotion.promotionType;
  promoDto.promotionCategory = promotion.promotionCategory ?? 0;
  promoDto.isLoseMessage = promotion.isLoseMessage;
  promoDto.isWinMessage = promotion.isWinMessage;
  promoDto.isTimeFrame = promotion.isTimeFrame;
  promoDto.aPILink = promotion.aPILink;
  promoDto.isIntergatePartner = promotion.isIntergatePartner;
  promoDto.operationType = promotion?.operationType;
  promoDto.operationId = promotion?.operationId;
  promoDto.productOwnerType = promotion?.productOwnerType;
  promoDto.productOwnerId = promotion?.productOwnerId;
  promoDto.partyPayFee = promotion?.partyPayFee;
  promoDto.partnerId = promotion?.partnerId;
  promoDto.idCombo = combo.id;
  promoDto.nameCombo = combo.name;
  promoDto.priceComboNew = combo.price;
  promoDto.priceComboOld = productForCombos.reduce((a, v) => a = a + v.sellingPrice, 0);
  promoDto.imageCombo = combo.image;
  promoDto.productForCombos = productForCombos;
  let tmp = productForCombos?.find(x => moment().isSameOrBefore(moment(x.expiredDate)));
  promoDto.expiredDateCombo = tmp ? tmp.expiredDate : null;
  promoDto.operationByDateList = promotion.operationByDateList;
  return promoDto;
}

function getProductForCombo(lstProductLayout: Array<VMProductInfoDto>, combo: ComboDto, lstPromotion: Array<PromotionDto>) {
  let lstProductForCombo = new Array<ProductDto>();
  combo?.products.forEach(elm => {
    let pro = lstProductLayout.find(x => x.id == elm.id);
    if (pro) {
      let dto = new ProductDto();
      dto.id = elm.id;
      dto.brandId = pro.brandId;
      dto.weightIncludePackaging = pro.weightIncludePackaging;
      dto.name = pro.name;
      dto.code = pro.code;
      dto.image = pro.image;
      dto.category = pro.category;
      dto.sellingPrice = pro.sellingPrice;
      dto.defaultPrice = pro.defaultPrice;
      dto.newPrice = elm.price;
      dto.expiredDate = pro.expiredDate;
      dto.qty = pro.quantity;
      dto.promotionList = [];

      let lstFilterDiscount = lstPromotion.filter(x => x.promotionCategory == CategoryPromotionEnum.PROMOTION_DISCOUNT);
      if (lstFilterDiscount.length > 0) {
        lstFilterDiscount.forEach(promoDiscount => {
          if (promoDiscount.isApplyAllProduct) {
            let isMatching = pro.ownerType == promoDiscount.productOwnerType && pro.ownerId == promoDiscount.productOwnerId;
            if (isMatching) {
              let promotionAdd = addPromotionDto(promoDiscount, null);
              promotionAdd.amountDiscount = promoDiscount.amountDiscount;
              promotionAdd.percentDiscount = promoDiscount.percentDiscount;
              dto.promotionList.push(promotionAdd);
            }
          } else {
            promoDiscount.products.forEach(proItem => {
              if (proItem.id == dto.id) {
                let promotionAdd = addPromotionDto(promoDiscount, proItem);
                promotionAdd.messages = promoDiscount.messages;
                dto.promotionList.push(promotionAdd);
              }
            });
          }
        });
      }
      lstProductForCombo.push(dto);
    }
  });
  return lstProductForCombo;
}

// Mã màu
function randomColor() {
  let r = Math.floor(Math.random() * 256);
  let g = Math.floor(Math.random() * 256);
  let b = Math.floor(Math.random() * 256);
  return 'rgb(' + r + ',' + g + ',' + b + ')';
}

function capchaCode(sCode) {
  let showNum = [];
  let canvasWinth = 100;
  let canvasHeight = 30;
  let canvas = document.getElementById('valicode') as HTMLCanvasElement;
  let context = canvas.getContext('2d');
  canvas.width = canvasWinth;
  canvas.height = canvasHeight;
  // let sCode = 'a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,0,1,2,3,4,5,6,7,8,9';
  let saCode = sCode.split(',');
  let saCodeLen = saCode.length;
  for (let i = 0; i <= 3; i++) {
    let sIndex = Math.floor(Math.random() * saCodeLen);
    let sDeg = (Math.random() * 20 * Math.PI) / 180;
    let cTxt = saCode[sIndex];
    showNum[i] = cTxt.toLowerCase();
    let x = 10 + i * 20;
    let y = 20 + Math.random() * 8;
    context.font = 'italic 20px Arial';
    context.translate(x, y);
    context.rotate(sDeg);

    context.fillStyle = randomColor();
    context.fillText(cTxt, 0, 0);

    context.rotate(-sDeg);
    context.translate(-x, -y);
  }
  // for (let i = 0; i <= 5; i++) {
  //     context.strokeStyle = randomColor();
  //     context.beginPath();
  //     context.moveTo(
  //         Math.random() * canvasWinth,
  //         Math.random() * canvasHeight
  //     );
  //     context.lineTo(
  //         Math.random() * canvasWinth,
  //         Math.random() * canvasHeight
  //     );
  //     context.stroke();
  // }
  // for (let i = 0; i < 30; i++) {
  //     context.strokeStyle = randomColor();
  //     context.beginPath();
  //     let x = Math.random() * canvasWinth;
  //     let y = Math.random() * canvasHeight;
  //     context.moveTo(x, y);
  //     context.lineTo(x + 1, y + 1);
  //     context.stroke();
  // }
  return showNum.join('');
}

function getContentClassNameByLang() {
  let lng = localStorage.getItem("lang") || "vi";
  return "content ".concat("content-bill-page-").concat(lng);
}

function removeVietnameseTones(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, " ");
  str = str.trim();
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
  return str;
}

/**
 * Kiểm tra vừa có tồn tại k/m giảm giá vừa tồn tại k/m ngoài layout => Ưu tiên ngoài layout
 */
function isCheckShowPromoParallel(product: VMProductInfoDto, promotion: PromotionDto) {
  if (promotion.promotionCategory == CategoryPromotionEnum.PROMOTION_NORMAL) {
    let lstCategoryPromotionInit = [CategoryPromotionEnum.PROMOTION_NO_DROP, CategoryPromotionEnum.PROMOTION_DROP_PRODUCT];
    let filterPromotionList = product?.promotionList.filter(x => lstCategoryPromotionInit.includes(x.promotionCategory));
    if (filterPromotionList && filterPromotionList.length > 0) {
      // Có tồn tại k/m khác thì ẩn Giảm giá khuyến mãi
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}
/**
 * Kiểm tra vừa có tồn tại k/m nhập voucher vừa tồn tại k/m ngoài layout => Ưu tiên ngoài layout
 */
function isCheckShowPromoVoucher(product: VMProductInfoDto, promotion: PromotionDto) {
  if (promotion.promotionCategory == CategoryPromotionEnum.PROMOTION_VOUCHER) {
    let lstCategoryPromotionInit = [CategoryPromotionEnum.PROMOTION_NO_DROP, CategoryPromotionEnum.PROMOTION_DROP_PRODUCT];
    let filterPromotionList = product?.promotionList.filter(x => lstCategoryPromotionInit.includes(x.promotionCategory));
    if (filterPromotionList && filterPromotionList.length > 0) {
      // Có tồn tại k/m khác thì ẩn nhập voucher
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}
/**
 * Kiểm tra vừa có tồn tại k/m nhập voucher vừa tồn tại k/m ngoài layout vừa k/m sampling => Ưu tiên Sampling
 */
function isCheckShowPromoSamling(product: VMProductInfoDto, promotion: PromotionDto) {
  if (promotion.promotionCategory == CategoryPromotionEnum.PROMOTION_SAMPLING) {
    let lstCategoryPromotionInit = [CategoryPromotionEnum.PROMOTION_NO_DROP, CategoryPromotionEnum.PROMOTION_DROP_PRODUCT, CategoryPromotionEnum.PROMOTION_VOUCHER];
    let filterPromotionList = product?.promotionList.filter(x => lstCategoryPromotionInit.includes(x.promotionCategory));
    if (filterPromotionList && filterPromotionList.length > 0) {
      // Có tồn tại k/m khác thì ẩn sampling
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

function isOpenBusiness(openTime, closeTime) {
  let isOpen: boolean = false;
  let currentTime = moment();
  let startTime = moment(openTime || BUSINESS_TIMER.OPEN_TIME, "HH:mm");
  let endTime = moment(closeTime || BUSINESS_TIMER.CLOSE_TIME, "HH:mm");
  if (
    currentTime.isSameOrAfter(startTime) &&
    currentTime.isSameOrBefore(endTime)
  ) {
    isOpen = true;
  }
  return isOpen;
}

function getPromotionByShowIcon(lstPromotion: Array<PromotionDto>) {
  let findItemShowIcon = lstPromotion?.find(x => x.isShowIcon);
  if (findItemShowIcon) {
    return findItemShowIcon;
  } else if (!findItemShowIcon && lstPromotion?.length > 0) {
    return lstPromotion[0];
  } else {
    return null;
  }
}

function getHash(dataStr: string) {
  let dataHash = dataStr.concat(localStorage.getItem("privateKey"));
  return md5(dataHash)
}

function getFullPath(url: string) {
  try {
    let isURL = url.includes("http");
    if (isURL) {
      return url;
    } else {
      var newUrl = process.env.REACT_APP_BASE_CDN_DOMAIN + url?.substring(1);
      return newUrl
    }
  } catch (error) {
    return url;
  }

}

function getBillNumber(walletCode: any) {
  let billNumber = makeUUID(32);
  try {
    switch (Number(walletCode)) {
      case WalletEnum.GALAXY:
        billNumber = makeUUID(25);
        break;
      default:
        billNumber = makeUUID(32);
    }
  } catch (error) {
    return billNumber;
  }
  return billNumber;
}

// Kiểm tra hai địa chỉ có tương tự không
function isLocationMatch(location: Location, to: any): boolean {
  const currentPathname = location.pathname;
  const currentSearch = location.search;
  if (typeof to === 'string') {
    return currentPathname + currentSearch === to;
  } else {
    const toPathname = to.pathname ?? '';
    const toSearch = to.search ?? '';
    return currentPathname === toPathname && currentSearch === toSearch;
  }
}


function getProductGroupByLayout(layout: ResLayoutDto, productList: Array<VMProductInfoDto>, vendingInfo: MachineDto) {
  productList.forEach(product => {
    let qty = 0;
    let qtyAll = 0;
    let maxBuy = 0;
    let firstExpired = null;
    let saleType = undefined;
    layout.subLayoutList?.forEach((sub: SubLayoutDto) => {
      sub.trayList?.forEach((tray: TrayDto) => {
        var lstslot = tray.slotList?.filter(x => Number(x.productId) == product.id);
        lstslot.forEach((slot: SlotDto) => {
          if (vendingInfo?.machineModelType != MachineModelTypeEnum.CAFE) {
            let checkExpiredDate = slot.cellList?.find(x => utils.checkStringValid(x.expiredDate) && moment().isSameOrAfter(moment(x.expiredDate)));
            if (slot.status == 1) {
              let quantity = 0;
              let quantityAll = 0;
              let sumQtyCell = slot.cellList?.reduce((a, v) => a = a + Number(v?.quantity ?? 0), 0) || 0;
              if (!vendingInfo?.minusWarehouseWhenNotDrop || vendingInfo?.minusWarehouseWhenNotDrop == MINUS_WAREHOUSE.MINUS) {
                quantity = Number(slot.quantity ?? 0);
                quantityAll = Number(sumQtyCell ?? 0);
              }
              else {
                quantity = Number(slot.quantity ?? 0) - Number(slot.refundCount ?? 0);
                quantityAll = Number(sumQtyCell) - Number(slot.refundCount ?? 0);
              }
              if (slot.quantity > 0) {
                if (!checkExpiredDate) {
                  qty += (quantity < 0 ? 0 : quantity);
                  maxBuy = Math.min(slot.maxBuyQuantity, qty);
                  let localfirstExpired = slot.cellList[0]?.expiredDate;
                  if (firstExpired == null) {
                    firstExpired = localfirstExpired;
                  }
                  else if (localfirstExpired != null && moment(firstExpired).isSameOrAfter(moment(localfirstExpired))) {
                    firstExpired = localfirstExpired;
                  }
                }
              }
              qtyAll += (quantityAll < 0 ? 0 : quantityAll);
            }
            if (!saleType) {
              if (slot.status == 0 || (slot.refundCount > 0 && vendingInfo?.minusWarehouseWhenNotDrop == MINUS_WAREHOUSE.NOT_MINUS)) {
                // Nếu có 1 ô có hàng bị khóa => Khóa hàng
                // Nếu có 1 ô có hàng refund (RefundCount>0) => Khóa hàng
                saleType = SALE_TYPE.LOCK;
              } else if (checkExpiredDate) {
                // Nếu có 1 ô có hàng hết hạn => Hết hạn
                saleType = SALE_TYPE.EXPIRED;
              }
            }
            product.lstTrayNo = [...product.lstTrayNo || [], tray.trayNo]
          }
          // else {
          // if (lstTube.length == 0) {
          //     qty = 0;
          // } else {
          //     if (slot.optionList[0].formularList == null || slot.optionList[0].formularList.length == 0) {
          //         qty = 0;
          //     } else {
          //         slot.optionList[0].formularList.forEach(formular => {
          //             if (formular.materialList == null || formular.materialList.length == 0) {
          //                 qty = 0;
          //             } else {
          //                 let minQuantity = 10000;
          //                 formular.materialList.forEach(material => {
          //                     if (material.quantity != null && material.quantity > 0) {
          //                         var tube = lstTube.find(x => x.vMPhysicalTubeId == material.vMPhysicalTubeId);
          //                         if (tube != null) {
          //                             //Ton kho chia can
          //                             let abc = (((tube.tubeQuantity ?? 0) - (tube.notSellLimit ?? 0)) / material.quantity);
          //                             if (abc < minQuantity) {
          //                                 minQuantity = abc;
          //                             }
          //                         }
          //                         else {
          //                             minQuantity = 0;
          //                         }
          //                     }
          //                     else {
          //                         minQuantity = 0;
          //                     }
          //                 });
          //                 // quantityCafe += minQuantity;
          //                 qty += minQuantity;
          //             }
          //         });
          //     }
          // }
          // qty = 1;
          // Cafe nên ngày hết hạn max
          // firstExpired = moment.max();
          // Cafe nên mua chỉ đc 1
          // maxBuy = 1;
          // }
        });
      });
    });
    if (product.category == PRODUCT_CATEGORY.SERVICE) {
      product.quantity = 1;
      product.quantityAll = 1;
      product.maxBuyQuantity = 1;
      product.expiredDate = new Date(moment().add(30, 'days').format("YYYY-MM-DD"));
      product.saleType = SALE_TYPE.NORMAL;
      product.trayNo = Math.min(...product?.lstTrayNo || [0]);
    } else {
      product.quantity = Number(qty ?? 0);
      product.quantityAll = Number(qtyAll ?? 0);
      product.maxBuyQuantity = Number(maxBuy ?? 0);
      product.expiredDate = firstExpired;
      product.saleType = (product.quantity > 0 ? SALE_TYPE.NORMAL : (saleType ? saleType : SALE_TYPE.OUT_STOCK))
      product.trayNo = Math.min(...product.lstTrayNo);
    }
  });
  return productList;
}


function getBillOffline(code: String, dataApp: any) {
  try {
    let cachedBillStr = localStorage.getItem(`bill_${code}`);
    let cachedVendingStr = localStorage.getItem(`vendingInfo_${code}`);
    let cachedlayout = localStorage.getItem(`layout_${code}`);
    let cachedPosition = localStorage.getItem(`position_${code}`);

    // let dataWeb = {
    //     command: TYPE_CAMMAND_W2A.W2A_WRITE_LOG,
    //     data: {
    //         action: "get-bill-offline",
    //         bill: JSON.parse(cachedBillStr),
    //         vendingInfo: JSON.parse(cachedVendingStr),
    //         layout: JSON.parse(cachedlayout),
    //         dataApp: dataApp,
    //     }
    // }
    // W2A.toroW2A(JSON.stringify(dataWeb));

    let vendingInfo = JSON.parse(cachedVendingStr) as MachineDto;
    if (!cachedBillStr || !cachedlayout || vendingInfo.mixType == MIX_TYPE.MIX || vendingInfo.machineModelType != MachineModelTypeEnum.NORMAL) {
      return null;
    } else {
      let bill = JSON.parse(cachedBillStr) as BillDto;
      if (bill.billNumber == dataApp.data.billNumber) {
        var layout = JSON.parse(cachedlayout) as ResLayoutDto;
        bill.billDetailList.forEach(detail => {
          // Tìm vị trí rớt hàng
          let itemPosition = undefined;
          let isBreak = false;

          let itemPositionDto = JSON.parse(cachedPosition) as any;
          if (itemPositionDto) {
            itemPosition = itemPositionDto;
          } else {
            layout.subLayoutList?.forEach((sub: SubLayoutDto, indexSub: number) => {
              if (!isBreak) {
                sub.trayList?.forEach((tray: TrayDto, indexTray: number) => {
                  if (!isBreak) {
                    tray.slotList?.forEach((slot: SlotDto, indexSlot: number) => {
                      if (!isBreak) {
                        let checkExpiredDate = slot.cellList?.find(x => utils.checkStringValid(x.expiredDate) && moment().isSameOrAfter(moment(x.expiredDate)));
                        if (!checkExpiredDate) {
                          let quantity = 0;
                          if (!vendingInfo?.minusWarehouseWhenNotDrop || vendingInfo?.minusWarehouseWhenNotDrop == "MINUS") {
                            quantity = Number(slot.quantity ?? 0);
                          }
                          else {
                            quantity = Number(slot.quantity ?? 0) - Number(slot.refundCount ?? 0);
                          }
                          if (quantity > 0 && slot.productId == detail.productId && slot.status == 1) {
                            if (vendingInfo.dropType == GOODS_DROP_TYPE.BIG_QUANTITY_FIRST) {
                              if (!itemPosition || quantity > (Number(itemPosition?.quantity ?? 0))) {
                                itemPosition = {
                                  indexSub: indexSub,
                                  indexTray: indexTray,
                                  indexSlot: indexSlot,
                                  subLayoutNo: sub.subLayoutId,
                                  trayNo: tray.trayNo,
                                  slot: slot,
                                  quantity: quantity,
                                }
                              }
                            } else if (vendingInfo.dropType == GOODS_DROP_TYPE.EXPIRE_FIRST) {
                              let firstExpired = slot.cellList[0]?.expiredDate;
                              if (!itemPosition || moment(firstExpired).isSameOrAfter(moment(itemPosition?.expiredDate))) {
                                itemPosition = {
                                  indexSub: indexSub,
                                  indexTray: indexTray,
                                  indexSlot: indexSlot,
                                  subLayoutNo: sub.subLayoutId,
                                  trayNo: tray.trayNo,
                                  slot: slot,
                                  expiredDate: slot.cellList[0]?.expiredDate
                                }
                              }
                            } else {
                              itemPosition = {
                                indexSub: indexSub,
                                indexTray: indexTray,
                                indexSlot: indexSlot,
                                subLayoutNo: sub.subLayoutId,
                                trayNo: tray.trayNo,
                                slot: slot,
                              }
                              isBreak = true;
                            }
                          }
                        }
                      }
                    });
                  }
                });
              }
            });
          }


          if (itemPosition) {
            // Gán thông tin cho bill detail
            let firstCell = itemPosition.slot.cellList[0];
            detail.billNumber = bill.billNumber;
            detail.subLayoutNo = itemPosition.subLayoutNo;
            detail.position = itemPosition.slot.position;
            detail.refId = firstCell.refId;
            detail.refType = firstCell.refType;
            detail.supplierPrice = firstCell.supplierPrice;
            detail.slotNo = itemPosition.slot.slotNo;
            detail.trayNo = itemPosition.trayNo;
            detail.cellNumber = itemPosition.slot.cellNumber;
            detail.vmLayoutSlotId = itemPosition.slot.vmLayoutSlotId;
            detail.fillQuantity = itemPosition.slot.fillQuantity;
            detail.fillSeqNo = firstCell.fillSeqNo;
            detail.warehouseInventorySummaryId = firstCell.warehouseInventorySummaryId;
            detail.expiredDate = firstCell.expiredDate
            detail.motionCode = null;
            detail.motionName = null;
            // Xoay lò xo
            let cellNo = 1;
            layout.subLayoutList[itemPosition.indexSub].trayList[itemPosition.indexTray].slotList[itemPosition.indexSlot].quantity -= 1;
            let cellList = layout.subLayoutList[itemPosition.indexSub].trayList[itemPosition.indexTray].slotList[itemPosition.indexSlot].cellList;
            let lengthCell = cellList?.length || 0;
            for (var i = cellNo - 1; i < lengthCell; i++) {
              var cell = cellList[i];
              if (i == lengthCell - 1) {
                cell.expiredDate = null;
                cell.quantity = 0;
                cell.refDetailId = null;
                cell.refId = null;
                cell.refType = null;
                cell.status = 0;
                cell.supplierPrice = 0;
                cell.warehouseInventorySummaryId = null;
              }
              else {
                var nextCell = cellList[i + 1];
                cell.expiredDate = nextCell.expiredDate;
                cell.quantity = nextCell.quantity;
                cell.refDetailId = nextCell.refDetailId;
                cell.refId = nextCell.refId;
                cell.refType = nextCell.refType;
                cell.status = nextCell.status;
                cell.supplierPrice = nextCell.supplierPrice;
                cell.warehouseInventorySummaryId = nextCell.warehouseInventorySummaryId;
              }
            }
          }
        });
        bill.status = "SUCCESS";
        bill.hash = undefined;
        bill.paymentList = undefined;
        bill.billDetails = [...bill.billDetailList];
        bill.billDetailList = undefined;
        return bill;
      } else {
        return null;
      }
    }
  } catch (error) {
    return null;
  }

}


function createOrderEvent(
  vendingInfo: MachineDto,
  code: string,
  subsource: string,
  queryString: string,
  ipAddress: string,
  paymentType: number,
  paymentMethod: string
) {

  const billNumber = utils.makeUUID(32);
  let bill = new BillDto();
  if (subsource == SUBSOURCE.VM) {
    var dataStr = billNumber.concat(code.toUpperCase()).concat(vendingInfo?.ownerId.toString()).concat(subsource);
    bill.hash = utils.getHash(dataStr);
  }
  bill.companyId = vendingInfo.companyId;
  bill.billNumber = billNumber;
  bill.paymentType = paymentType;
  bill.transactionCode = billNumber;
  bill.machineCode = code;
  bill.orderAmount = 0;
  bill.orderQuantity = 1;
  bill.orderPromoAmount = 0;
  bill.orderParnerPromoAmount = 0;
  bill.promotionId = 0;
  bill.paymentMethod = paymentMethod ? paymentMethod : "WEB2APP";;
  bill.successRedirectUrl = window.location.origin + "/result-payment".concat(billNumber ? `?billId=${billNumber}` : "").concat(code ? `&code=${code}` : "");
  bill.failRedirectUrl = window.location.origin + "/bill-fail".concat(billNumber ? `?billId=${billNumber}` : "").concat(code ? `&code=${code}` : "");
  bill.subOrderSource = utils.checkStringValid(subsource) ? subsource : "Direct";
  bill.orderUrl = window.origin.concat(queryString);
  bill.notePO = "Bill from TOROGO";
  bill.ipAddress = ipAddress;
  bill.memberId = null;
  bill.finalAmount = 0;
  bill.quantity = 0;
  bill.extraInfo = null;
  bill.parentTransactionCodeRefund = "";
  bill.state = "";
  bill.amount = 0;
  bill.originAmount = 0;
  bill.voucherAmount = 0;
  bill.partyPayFee = null;
  bill.voucherSystem = "VENDING";
  bill.ownerId = vendingInfo.ownerId;
  bill.ownerName = vendingInfo.ownerName;
  bill.vmOwnerType = vendingInfo.vmOwnerType;
  bill.locationAreaMachineId = vendingInfo.locationAreaMachineId;
  bill.localTime = moment()?.format("YYYY-MM-DDTHH:mm:ss.SSS");
  bill.billDetails = [];
  bill.lastChangeData = vendingInfo.lastChangeData;
  bill.platformType = getPlatformType();
  return bill;
}

function getPromotionByOperation(product: VMProductInfoDto) {
  let promotionList = [];
  if (product) {
    let isPromotionNormal = product.promotionList?.find(x => x.promotionCategory == CategoryPromotionEnum.PROMOTION_NORMAL);
    product.promotionList.forEach(pro => {
      const isAddPromotion = isAddPromotionOperation(pro);
      if (isAddPromotion) {
        promotionList.push(pro);
      } else {
        if (isPromotionNormal) {
          product.newPrice = product.sellingPrice;
        }
      }
    })
  }
  return promotionList;
}

function getPromotionComboByOperation(promotionComboDto: PromotionDto) {
  const isAddPromotion = isAddPromotionOperation(promotionComboDto);
  if (isAddPromotion) {
    return true
  }
  return false;
}

function verifySignature(partnerCode: string, partnerKey: string, transactionCode: string, requestTime: string, signature: string) {
  const gSign = md5(partnerCode + transactionCode + requestTime + partnerKey)
  if (gSign === signature) {
    return true;
  }
  return false;
}

// MD5(billId | amount | status | partnerTransCode | mid | tid | secretKey) 
function verifySignatureVinaId(data: string) {
  return md5(data)
}


function createOrderWallet(
  billNumber: string,
  vendingInfo: MachineDto,
  code: string,
  subsource: string,
  queryString: string,
  ipAddress: string,
  paymentType: number,
  paymentMethod: string,
) {


  let bill = new BillDto();
  if (subsource == SUBSOURCE.VM) {
    var dataStr = billNumber.concat(code.toUpperCase()).concat(vendingInfo?.ownerId.toString()).concat(subsource);
    bill.hash = utils.getHash(dataStr);
  }
  bill.companyId = vendingInfo.companyId;
  bill.billNumber = billNumber;
  bill.paymentType = paymentType;
  bill.transactionCode = billNumber;
  bill.machineCode = code;
  bill.orderAmount = 0;
  bill.orderQuantity = 1;
  bill.orderPromoAmount = 0;
  bill.orderParnerPromoAmount = 0;
  bill.promotionId = 0;
  bill.paymentMethod = paymentMethod ? paymentMethod : "WEB2APP";;
  bill.successRedirectUrl = "/result-payment".concat(billNumber ? `?billId=${billNumber}` : "").concat(code ? `&code=${code}` : "");
  bill.failRedirectUrl = "/bill-fail".concat(billNumber ? `?billId=${billNumber}` : "").concat(code ? `&code=${code}` : "");
  bill.subOrderSource = utils.checkStringValid(subsource) ? subsource : "Direct";
  bill.orderUrl = window.origin.concat(queryString);
  bill.notePO = "Bill from TOROGO";
  bill.ipAddress = ipAddress;
  bill.memberId = null;
  bill.finalAmount = 0;
  bill.quantity = 0;
  bill.extraInfo = null;
  bill.parentTransactionCodeRefund = "";
  bill.state = "";
  bill.amount = 0;
  bill.originAmount = 0;
  bill.voucherAmount = 0;
  bill.partyPayFee = null;
  bill.voucherSystem = "VENDING";
  bill.ownerId = vendingInfo.ownerId;
  bill.ownerName = vendingInfo.ownerName;
  bill.vmOwnerType = vendingInfo.vmOwnerType;
  bill.locationAreaMachineId = vendingInfo.locationAreaMachineId;
  bill.localTime = moment()?.format("YYYY-MM-DDTHH:mm:ss.SSS");
  bill.billDetails = [];
  bill.lastChangeData = vendingInfo.lastChangeData;
  bill.platformType = getPlatformType();
  return bill;
}

function getPlatformType() {
  var isMobile =
    /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
      navigator.userAgent
    );
  if (isMobile) {
    return "MWEB";
  } else {
    return "PC";
  }
}

function safeConcat(value: any) {
  return value !== undefined ? value : "";
}

// trả về true nếu là Kootoro
function checkDomainKootoro(currentUrl: string) {
  const blueOceanDomains = ["payment.blueoceanlaundry.vn", "vending-blueoceanlaundry-korogo-qa"]
  const isBlueOceanDomain = blueOceanDomains.some(domain => currentUrl.includes(domain));
  return !isBlueOceanDomain;
}

function checkDomainBlueoceanlaundry(currentUrl: string) {
  const blueOceanDomains = ["payment.blueoceanlaundry.vn", "vending-blueoceanlaundry-korogo-qa", "localhost:3000"]
  const isBlueOceanDomain = blueOceanDomains.some(domain => currentUrl.includes(domain));
  return isBlueOceanDomain;
}